module.exports = __webpack_public_path__ + "_/_/common/source/assets/images/phone-with-message.svg";